export default "__VITE_ASSET__CsZUx8gc__"